<template>
  <div class="relative z-40 w-full" ref="dropdownRef">
    <div class="mb-2" v-if="label.trim() !== ''">
      <label class="font-medium text-base leading-5 text-[#000000]">{{
        label
      }}</label>
    </div>

    <button
      type="button"
      @click="toggleDropdown"
      class="flex justify-between w-full text-sm font-normal rounded-lg focus:outline-none"
      :class="{
        'bg-inputGrey-500 text-inputGrey-600': disabled,
        ' bg-inputGrey-500': !disabled,
        'p-2 border border-gray-300 text-gray-700': tableFilter,
        'px-3.5 py-4 text-inputGrey-900': !tableFilter,
      }"
      :disabled="disabled"
    >
      <span> <slot name="icon"></slot></span>
      <span class="flex-1 text-left">
        {{ selectedLabel ? selectedLabel : buttonText }}
      </span>

      <section>
        <div v-if="!loading">
          <span
            :class="{
              'rotate-180 ease-in-out duration-700': isOpen,
              'rotate-0 ease-in-out duration-700': !isOpen,
            }"
            ><img v-if="!disabled" src="@/assets/svg/arrow-down.svg" alt="" />
            <img v-else src="@/assets/svg/arrow-down-disabled.svg" alt=""
          /></span>
        </div>

        <ClipLoaderVue v-else color="inputGrey-900" :size="20" />
      </section>
    </button>

    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div
        v-if="isOpen"
        class="mt-2 bg-inputGrey-50 border border-inputGrey-600 rounded-lg text-green-500 px-3 py-4 h-[266px] overflow-y-scroll main w-full"
        :class="{ absolute: isOverlay }"
      >
        <ul class="h-[266px]">
          <li v-if="hasSearch">
            <EpumpInputVue
              :label="''"
              :passwordRevealToggle="false"
              :clearSearch="false"
              :placeholder="'Search'"
              :status="'dropdownSearch'"
              :type="'text'"
              :forgotPassword="false"
              :validation="false"
              @input="searchItems($event)"
              @clear="clearInput($event)"
              ><img src="@/assets/svg/search.svg" class="w-5 h-5"
            /></EpumpInputVue>
          </li>
          <li
            v-for="(option, index) in filteredItems"
            :key="index"
            @click="selectOption(option)"
            class="px-4 py-3 mb-2 text-sm font-normal border-gray-200 rounded-lg cursor-pointer text-inputGrey-900 bg-inputGrey-500 hover:bg-inputGrey-600 focus:outline-none"
          >
            {{ option.label }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import EpumpInputVue from "@/components/UI/Inputs/EpumpInput.vue";
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    buttonText: {
      type: String,
      default: "Select",
    },
    isOverlay: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
    tableFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    filteredItems() {
      return this.options.filter((item) => {
        const searchLower = this.searchQuery.toLowerCase();
        return item.label.toLowerCase().includes(searchLower);
      });
    },
  },
  components: {
    EpumpInputVue,
  },
  data() {
    return {
      isOpen: false,
      selectedLabel: null,
      searchQuery: "",
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("select", option);
      this.selectedLabel = option.label;
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (
        this.$refs.dropdownRef &&
        !this.$refs.dropdownRef.contains(event.target)
      ) {
        this.isOpen = false;
      }
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.offsetHeight;
      el.style.transition = "opacity 0.7s ease-in-out";
      el.style.opacity = 1;
      done();
    },
    beforeLeave(el) {
      el.style.opacity = 1;
    },
    leave(el, done) {
      el.style.transition = "opacity 0.3s ease-in-out";
      el.style.opacity = 0;
      setTimeout(() => {
        done();
      }, 300);
    },
    searchItems(e) {
      this.searchQuery = e.target?.value;
    },
    clearInput(e) {
      this.searchQuery = e;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
/* The transition classes are handled by JS hooks */
.main::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari, and Opera */
}

.main {
  -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer and Edge */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
}
</style>
